/* eslint max-len: 0 */

import React from 'react';
import { Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

type Props = {
  readonly company?: string;
  readonly fromDashboard?: string;
};

const HelpAdminUsers = (props: Props) => {
  return (
    <div style={{ padding: 5 }}>
      <Typography variant="body1" style={{ marginTop: 15, marginBottom: 10 }}>
        {props.fromDashboard ? (
          <Button component={Link} to="/administration/users" size="small" color="secondary">
            <FormattedMessage id="nav.administration.users" />
          </Button>
        ) : (
          <Typography variant={'subtitle2'}>
            <FormattedMessage id="nav.administration.users" />
          </Typography>
        )}
      </Typography>
      <div style={{ paddingLeft: 15, paddingRight: 15 }}>
        <Typography variant="subtitle2" align="justify">
          <FormattedMessage id="help.administration.users" />
        </Typography>
        <p></p>
        <Typography variant="subtitle2" align="justify">
          <FormattedMessage id="help.administration.users.1" />
        </Typography>
        <p></p>
        <Typography variant="body2" align="justify">
          <FormattedMessage id="help.administration.users.2" />
        </Typography>
        <p></p>
        {!props.fromDashboard && (
          <>
            <Typography variant="body2" align="justify">
              <FormattedMessage id="help.administration.users.3" />
            </Typography>
            <p></p>
            <Typography variant="body2" align="justify">
              <FormattedMessage id="help.administration.customers.23" />
            </Typography>
            <p></p>
            <div style={{ paddingLeft: 15, paddingRight: 15, textAlign: 'justify' }}>
              <Typography variant="body2" align="justify">
                <FormattedMessage id="help.administration.customers.24" />
              </Typography>
              <Typography variant="body2" align="justify">
                <FormattedMessage id="help.administration.customers.25" />
              </Typography>
              <Typography variant="body2" align="justify">
                <FormattedMessage id="help.administration.customers.26" />
              </Typography>
              <Typography variant="body2" align="justify">
                <FormattedMessage id="help.administration.customers.27" />
              </Typography>
            </div>
          </>
        )}
        <p></p>
        <Typography variant="body2" align="justify">
          <FormattedMessage id="help.administration.users.4" />
        </Typography>
        <p></p>
        <Typography variant="body2" align="justify">
          <FormattedMessage id="help.administration.users.5" />
        </Typography>
        <p></p>
        <Typography variant="body2" align="justify">
          <FormattedMessage id="help.administration.customers.30" />
        </Typography>
      </div>
    </div>
  );
};

export default HelpAdminUsers;
